import { z } from 'zod';

export const ExplainTextLlmResponseSchema = z.object({
  explanation: z.string().min(1, 'Explanation cannot be empty.'),
});

export type IExplainTextLlmResponseDto = z.infer<
  typeof ExplainTextLlmResponseSchema
>;
